<template>
    <div class="home">
        <HomeHeader :configs="home.hero" />
        <HowItWorks id="como-funciona" :configs="how_it_works" />
        <Description v-if="description.title" :configs="description" />
        <Level id="niveis" v-if="verifiedEmptyArray(levels)" />
        <Prize id="premios" v-if="!hideCashback && verifiedEmptyArray(prizes)" />
        <Faq id="FAQ" v-if="verifiedEmptyArray(faq.items)" />
        <RegisterBanner />
    </div>
</template>

<script>
import HomeHeader from "./Home/HomeHeader"
import RegisterBanner from "@/components/RegisterBanner"
import HowItWorks from "./Home/HowItWorks"
import Description from "./Home/Description"
import Faq from "./Home/FAQ"
import Level from './Home/Level'
import Prize from './Home/Prizes'

import { mapGetters } from "vuex"

export default {
    name: "home",
    components: {
        HomeHeader,
        HowItWorks,
        Description,
        Level,
        Prize,
        Faq,
        RegisterBanner,
    },
    computed: {
        ...mapGetters({
            home: 'company/home',
            how_it_works: 'company/how_it_works',
            description: 'company/description',
            faq: 'company/faq',
            levels: 'level/levels',
            prizes: 'prizes/prizes',
            hideCashback: 'company/hide_cashback',
        })
    },
    methods: {
        verifiedEmptyArray(array) {
            const arr = (Array.isArray(array) ? array.filter(item => !this.$lodash.isEmpty(item)) : [])
            return arr.length
        }
    },
}
</script>
